import locale from "@bonliva-crm/locale";
import { isAxiosError } from "axios";

type SaveDayErrorBody = {
  name?: string | null;
  description?: string | null;
};

/**
 * The text a refused day save is shown as.
 *
 * timereport-api answers hours on a report past Draft with
 * 409 { name: "timereport_rows_locked" } (ADR-0008). Its description is the
 * English exception message with the report id in it, which tells a CRM user
 * nothing about what to do, so that one refusal gets a Swedish message
 * (CRMDEV-7485). Every other refusal keeps the server's own wording.
 */
export function saveDayErrorMessage(
  body: SaveDayErrorBody | null | undefined,
  fallback: string
): string {
  if (body?.name === "timereport_rows_locked") {
    return locale.TimereportRowsLocked;
  }

  return body?.description || body?.name || fallback;
}

/**
 * The snackbar a refused day save is shown as. A duplicate-booking refusal explains which
 * other booking holds the hours and what to do about it; five seconds is not long enough to
 * read that before it slides away.
 */
export function saveDayErrorSnackbar(error: unknown): {
  text: string;
  duration?: number;
} {
  if (!isAxiosError(error)) {
    return { text: "Unknown error" };
  }

  const body = error.response?.data;
  const text = saveDayErrorMessage(body, error.message);

  return body?.name === "duplicate_booking_overlap"
    ? { text, duration: 15000 }
    : { text };
}
